import { SavedBiography } from "pages";
import routesMap from "routeControl/userRouteMap";

export default function route() {
  return [
    {
      path: routesMap.SAVEDBIOGRAPHY.path,
      name: "Saved Memorials",
      key: routesMap.SAVEDBIOGRAPHY.path,
      commonRoute: false,
      private: true,
      withAuth: false,
      belongsToHeader: true,
      element: <SavedBiography />,
    },
  ];
}
